// extracted by mini-css-extract-plugin
export var bounce = "_no-1";
export var generatingText = "_no-6";
export var lightning = "_no-4";
export var popup = "_no-5";
export var progressBar = "_no-7";
export var progressFill = "_no-8";
export var progressShimmer = "_no-9";
export var progressText = "_no-a";
export var shimmer = "_no-3";
export var uploadIcon = "_no-0";
export var uploadingText = "_no-2";